export const seoKeywords = {
  name: 'keywords',
  content:
    'fintech software development company, fintech software services, fintech development services, fintech product development, custom fintech product, fintech developers to hire',
};

export const fintechSoftwareDevelopmentPageSeo = {
  title: 'Fintech Product Development Company | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish engineers have extensive experience in fintech software development and use battle-tested tools to bring your financial product to the next level. We’re well aware of how important security and privacy are when it comes to financial management software - no matter if you’re building a crypto exchange, a digital wallet, or a money transfer platform.',
    },
  ],
};
